module.exports = __webpack_public_path__ + "img/plus.9b5f0554.svg";